import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { openMap } from '@/utils';
import Drip from 'drip';
export default {
  props: {
    shopName: String,
    mtCityId: String,
    // 美团城市id
    cityName: String,
    shopId: String,
    address: String,
    lat: Number,
    lng: Number,
    isLive: Boolean,
    performanceId: Number,
    showHotelReservation: Boolean,
    // 是否展示”订酒店“入口
    hotelReservation: Boolean,
    // 是否展示”订酒店“入口
    showStartDate: String,
    // 美团酒店展示的入住日期
    showEndDate: String,
    // 美团酒店展示的离店日期
    matchedShopName: String,
    // 真实的场馆名

    // 直线距离 后端计算返回
    straightLineDistance: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var _Drip$UA, _Drip$UA2, _Drip$constant;
    return {
      isFromMtwxapp: Drip.UA.IS_WXAPP_MEITUAN || Drip.UA.IS_WXAPP_MEITUAN_PINCHANG,
      isXiaohongshuAppOrMSite: (Drip === null || Drip === void 0 ? void 0 : (_Drip$UA = Drip.UA) === null || _Drip$UA === void 0 ? void 0 : _Drip$UA.IS_MAOYAN_XHS_APP) || (Drip === null || Drip === void 0 ? void 0 : (_Drip$UA2 = Drip.UA) === null || _Drip$UA2 === void 0 ? void 0 : _Drip$UA2.IS_MAOYAN_XHSMOVIE) || (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant = Drip.constant) === null || _Drip$constant === void 0 ? void 0 : _Drip$constant.sellChannel) === 13
    };
  },
  mounted: function mounted() {
    window.seedAction({
      evt: 'view',
      bid: 'b_movie_b_q9p6kdod_mv',
      cid: 'c_c21utqjf',
      abtest: 1,
      custom: {
        performance_id: this.performanceId
      }
    });
  },
  watch: {
    showHotelReservation: {
      handler: function handler(newVal) {
        if (!this.isFromMtwxapp && newVal) {
          // 订酒店按钮曝光埋点
          window.seedAction({
            evt: 'view',
            bid: 'b_movie_nzij9p2t_mv',
            cid: 'c_c21utqjf',
            custom: {
              city_id: this.mtCityId,
              performance_id: this.performanceId
            }
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    navToMap: function navToMap() {
      if (this.isFromMtwxapp) {
        // 美团小程序无法跳转到腾讯的域名，如果要支持的话，需要联系美团小程序给腾讯的域名加白名单
        return;
      }
      window.lxTagReport('c_c21utqjf', 'b_q9p6kdod', {
        performance_id: this.performanceId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_q9p6kdod',
        cid: 'c_c21utqjf',
        abtest: 1,
        custom: {
          performance_id: this.performanceId
        }
      });
      if (this.isLive) return;
      if (location.href.includes('fromSearch=true')) {
        return;
      }
      var shopId = this.shopId,
        lat = this.lat,
        lng = this.lng,
        address = this.address,
        shopName = this.shopName;
      openMap({
        shopId: shopId,
        lat: lat,
        lng: lng,
        address: address,
        shopName: shopName
      });
    },
    navToHotel: function navToHotel(event) {
      // 阻止事件冒泡
      event.stopPropagation();
      var baseUrl = 'imeituan://www.meituan.com/hotel/list';
      var previousPageCode = 'maoyan_perform_detail';
      var url = [baseUrl, "?cityId=".concat(this.mtCityId || ''), "&cityName=".concat(this.cityName || ''), "&checkInDate=".concat(this.showStartDate || ''), "&checkOutDate=".concat(this.showEndDate || ''), "&q=".concat(this.matchedShopName || this.shopName || ''), "&previousPage=".concat(previousPageCode), "&latitude=".concat(this.lat || ''), "&longitude=".concat(this.lng || ''), "&shopID=".concat(this.shopId || '')].join('');

      // 订酒店按钮点击埋点
      window.lxTagReport('c_c21utqjf', 'b_movie_nzij9p2t_mc', {
        city_id: this.mtCityId,
        performance_id: this.performanceId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_nzij9p2t_mc',
        cid: 'c_c21utqjf',
        custom: {
          city_id: this.mtCityId,
          performance_id: this.performanceId
        }
      });
      this.go(url);
    }
  }
};